import { render, staticRenderFns } from "./HuntingWordsPage.vue?vue&type=template&id=4ab8426e&"
import script from "./HuntingWordsPage.vue?vue&type=script&lang=js&"
export * from "./HuntingWordsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports